import qs from 'query-string';
import {
  AUTHKIT_SESSION, LOGOUT, GET_USER_PROFILE, GET_USERS, GET_USER, CREATE_USER, SAVE_USER,
  USER_OP_CREATE, USER_OP_ROTATE, ENABLE_TWO_FACTOR, DISABLE_TWO_FACTOR,
  VERIFY_TWO_FACTOR,
} from '../constants';

// Stores a token obtained from AuthKit (initial PKCE exchange or a refresh).
export const authkitSession = token => ({
  type: AUTHKIT_SESSION,
  payload: {
    data: token,
  },
});

export const logout = () => ({
  type: LOGOUT,
  payload: {},
});

export const getCurrentUser = token => ({
  type: GET_USER_PROFILE,
  payload: {
    request: {
      method: 'get',
      url: '/v1/users/me',
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    },
  },
});

export const getUsers = (query, status, organization, from, limit) => ({
  type: GET_USERS,
  payload: {
    request: {
      method: 'get',
      url: `/v1/admin/users?${qs.stringify({
        query, status, from, limit, organization,
      })}`,
    },
  },
});

export const createUser = data => ({
  type: CREATE_USER,
  payload: {
    request: {
      method: 'post',
      data,
      url: '/v1/admin/users/',
    },
  },
});

export const getUser = id => ({
  type: GET_USER,
  payload: {
    request: {
      method: 'get',
      url: `/v1/admin/users/${id}`,
    },
  },
});

export const saveUser = (id, data) => ({
  type: SAVE_USER,
  payload: {
    request: {
      method: 'patch',
      data,
      url: `/v1/admin/users/${id}`,
    },
  },
});

export const onePasswordCreate = id => ({
  type: USER_OP_CREATE,
  payload: {
    request: {
      method: 'patch',
      url: `/v1/admin/users/${id}/1password/create`,
    },
  },
});

export const onePasswordRotate = id => ({
  type: USER_OP_ROTATE,
  payload: {
    request: {
      method: 'patch',
      url: `/v1/admin/users/${id}/1password/rotate`,
    },
  },
});

export const enableTwoFactor = (token, data) => ({
  type: ENABLE_TWO_FACTOR,
  payload: {
    request: {
      method: 'post',
      url: '/v1/users/twofactor',
      data,
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    },
  },
});

export const disableTwoFactor = () => ({
  type: DISABLE_TWO_FACTOR,
  payload: {
    request: {
      method: 'delete',
      url: '/v1/users/twofactor',
    },
  },
});

export const verifyTwoFactor = (userId, code) => ({
  type: VERIFY_TWO_FACTOR,
  payload: {
    request: {
      method: 'post',
      url: `/v1/users/${userId}/twofactor/verify/${code}`,
    },
  },
});

export const getUsersNonAdmin = (query, status, organization, from, limit) => ({
  type: GET_USERS,
  payload: {
    request: {
      method: 'get',
      url: `/v1/users?${qs.stringify({
        query, status, from, limit, organization,
      })}`,
    },
  },
});
